import EditMyEMSParcelContiainer from "../containers/EditMyEMSParcelContainer";

const EditMyEMSParcelsPage = () => {
    return <EditMyEMSParcelContiainer />;
};

export default EditMyEMSParcelsPage;
